import { render, staticRenderFns } from "./RsaAccettazioneRicetteEditComponent.vue?vue&type=template&id=c121ea9c"
import script from "./RsaAccettazioneRicetteEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneRicetteEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports